var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-container-vertical"},[_c('ht-nav-bar'),_c('div',{staticClass:"app-main"},[_c('ht-side-bar'),_c('ht-app-main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }